import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';

import './styles.css';

import icBuyEnabled from '../../assets/imgs/ic_buy_enabled.svg?react';
import icBuyDisabled from '../../assets/imgs/ic_buy_disabled.svg?react';
import icUseEnabled from '../../assets/imgs/ic_use_enabled.svg?react';
import icUseDisabled from '../../assets/imgs/ic_use_disabled.svg?react';
import icProfileEnabled from '../../assets/imgs/ic_profile_enabled.svg?react';
import icProfileDisabled from '../../assets/imgs/ic_profile_disabled.svg?react';
import { RootState } from 'redux/reducers/rootReducer';

type FooterProps = {
    isShow: boolean;
    isActiveTicketShown: boolean;
    colorFontBottom: string;
};

const Footer = memo(({ isShow, isActiveTicketShown, colorFontBottom }: FooterProps) => {
    const { t } = useTranslation();
    const location = useLocation();
    const isTicket = location.pathname.includes('/bought');
    const isHomePage = location.pathname.includes('/buy');
    const isMyPage = location.pathname.includes('/profile');
    const textColorEnabled = isActiveTicketShown
        ? colorFontBottom
        : getComputedStyle(document.documentElement).getPropertyValue('--text-color');
    const textColorDisabled = getComputedStyle(document.documentElement).getPropertyValue('--inactive-color');

    return (
        <>
            {isShow && (
                <div className={`footer-container ${isTicket && isActiveTicketShown ? 'footer-container-ticket' : ''}`}>
                    <LinkForward
                        to="buy"
                        image={isHomePage ? icBuyEnabled : icBuyDisabled}
                        width={40}
                        height={40}
                        marginLeft={6}
                        marginTop={6}
                        className={'footer-item-border'}
                        textColor={isHomePage ? textColorEnabled : textColorDisabled}
                    >
                        {t('footer.home-page')}
                    </LinkForward>
                    <LinkForward
                        to="bought"
                        image={isTicket ? icUseEnabled : icUseDisabled}
                        width={40}
                        height={40}
                        marginLeft={6}
                        marginTop={6}
                        className={'footer-item-border'}
                        textColor={isTicket ? textColorEnabled : textColorDisabled}
                    >
                        {t('footer.bought')}
                    </LinkForward>
                    <LinkForward
                        to="profile"
                        image={isMyPage ? icProfileEnabled : icProfileDisabled}
                        width={22}
                        height={25}
                        marginLeft={0}
                        marginTop={5}
                        className={'footer-item'}
                        textColor={isMyPage ? textColorEnabled : textColorDisabled}
                    />
                </div>
            )}
        </>
    );
});

export default connect((state: RootState) => ({
    isActiveTicketShown: state.isActiveTicketShown,
    colorFontBottom: state.currentTheme.colorFontBottom,
}))(Footer);

type LinkForwardProps = {
    to: string;
    image: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    width: number;
    height: number;
    marginLeft: number;
    marginTop: number;
    children?: React.ReactNode;
    className?: string;
    textColor?: string;
    [key: string]: any;
};

function LinkForward({
    to,
    image,
    width,
    height,
    marginLeft,
    marginTop,
    children,
    className,
    textColor,
    ...props
}: LinkForwardProps) {
    return (
        <Link className={className} to={to} {...props}>
            {React.createElement(image, {
                width: width,
                height: height,
            })}
            <p
                style={{
                    fontWeight: 'bold',
                    fontSize: 16,
                    marginLeft: marginLeft,
                    marginTop: marginTop,
                    color: textColor,
                }}
            >
                {children}
            </p>
        </Link>
    );
}
